import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./global.css";
import "./App.css";

// Componentes iniciales que no requieren lazy loading (para evitar parpadeos en login)
import Index from "./pages/Index";
import RutaLogged from "./componentes/login/RutaLogged";
import RutaLayoutLogged from "./componentes/login/RutaLayoutLogged";

// Carga perezosa (Lazy Loading) de los módulos
const ControlPanel = lazy(() => import("./pages/ControlPanel"));
const SubirDatos = lazy(() => import("./componentes/subirdatos/SubirDatos"));
const ListaCartera = lazy(() => import("./componentes/listacartera/ListaCartera"));
const CompromisoPago = lazy(() => import("./componentes/pagos/CompromisoPago"));
const Visitas = lazy(() => import("./componentes/visitas/Visitas"));
const Cobros = lazy(() => import("./componentes/cobros/Cobros"));
const Opciones = lazy(() => import("./componentes/opciones/Opciones"));
const Modulos = lazy(() => import("./componentes/modulos/Modulos"));
const Menu = lazy(() => import("./componentes/menu/Menu"));
const Gestores = lazy(() => import("./componentes/mantenimiento/gestores/Gestores"));
const OpcionesGestor = lazy(() => import("./componentes/mantenimiento/opcionesgestor/OpcionesGestor"));
const Cargo = lazy(() => import("./componentes/cargo/Cargo"));
const Roles = lazy(() => import("./componentes/roles/Roles"));
const Permisos = lazy(() => import("./componentes/permisos/Permisos"));
const Usuarios = lazy(() => import("./componentes/usuarios/Usuarios"));
const GestionarEmpresa = lazy(() => import("./componentes/empresas/GestionarEmpresas"));
const PerfilGestor = lazy(() => import("./componentes/mantenimiento/perfilgestor/PerfilGestor"));
const AsignarCartera = lazy(() => import("./componentes/asignarcartera/AsignarCartera"));
const Talleres = lazy(() => import("./componentes/talleres/Talleres"));
const ManodeObra = lazy(() => import("./componentes/manodeobra/Manodeobra"));
const Repuestos = lazy(() => import("./componentes/repuestos/Repuestos"));
const TipoRegistros = lazy(() => import("./componentes/tiporegistros/Tiporegistros"));
const Kilometraje = lazy(() => import("./componentes/kilometraje/Kilometraje"));
const GestionarAlmacenes = lazy(() => import("./componentes/gestionaralmacenes/GestionarAlmacenes"));
const Intermediarios = lazy(() => import("./componentes/intermediarios/Intermediarios"));
const ClienteFinal = lazy(() => import("./componentes/clientefinal/ClienteFinal"));
const StockDistribuidor = lazy(() => import("./componentes/stockdistribuidor/StockDistribuidor"));
const StockConsolidado = lazy(() => import("./componentes/stockconsolidado/StockConsolidado"));
const Activaciones = lazy(() => import("./componentes/activaciones/Activaciones"));
const Retail = lazy(() => import("./componentes/retail/Retail"));
const OrdendePago = lazy(() => import("./componentes/ordendepago/OrdendePago"));
const Descargarreportes = lazy(() => import("./componentes/descargarreportes/Descargarreportes"));
const SubirImagenes = lazy(() => import("./componentes/subirimagenes/SubirImagenes"));
const OrdenLiquidadas = lazy(() => import("./componentes/ordendeliquidadas/Ordendeliquidadas"));
const Descargarreportesorden = lazy(() => import("./componentes/descargarreportesorden/Descargarreportesorden"));
const InventarioReportes = lazy(() => import("./componentes/inventarioreportes/InventarioReportes"));
const GarantiasAprobadas = lazy(() => import("./componentes/garantiasaprobadas/GarantiasAprobadas"));
const Garantiasaporaprobar = lazy(() => import("./componentes/garantiasaporaprobar/Garantiasaporaprobar"));
const DashBoardPostVenta = lazy(() => import("./componentes/dashdoardpostventa/DashBoardPostVenta"));
const DashboardCartera = lazy(() => import("./componentes/dashboardcartera/DashboardCartera"));
const DashboardInventario = lazy(() => import("./componentes/dashboardinventario/DashboardInventario"));
const GarantiasRechazadas = lazy(() => import("./componentes/garantiasrechazadas/GarantiasRechazadas"));
const Noticias = lazy(() => import("./componentes/noticias/Noticias"));
const MapaTalleres = lazy(() => import("./componentes/mapatalleres/MapaTalleres"));

function App() {
  return (
    <Router>
      <div>
        <Suspense fallback={
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '1.5rem', color: '#555' }}>
            Cargando módulo...
          </div>
        }>
          <Switch>
            <Route component={Index} exact path="/" />
            
            <RutaLayoutLogged component={ControlPanel} path="/dashboard" />
            <RutaLogged component={GarantiasRechazadas} path="/garantiasrechazadas" />
            <RutaLogged component={DashboardCartera} path="/cartera" />
            <RutaLogged component={DashboardInventario} path="/inventario" />
            <RutaLogged component={SubirDatos} path="/subirdatos" />
            <RutaLayoutLogged component={ListaCartera} path="/listacartera" />
            <RutaLayoutLogged component={DashBoardPostVenta} path="/postventa" />
            <RutaLogged component={CompromisoPago} path="/pagos" />
            <RutaLogged component={Cobros} path="/cobros" />
            <RutaLogged component={Visitas} path="/visitas" />
            <RutaLogged component={Opciones} path="/opciones" />
            <RutaLogged component={Modulos} path="/modulos" />
            <RutaLogged component={Usuarios} path="/usuarios" />
            <RutaLogged component={Menu} path="/menu" />
            <RutaLogged component={Cargo} path="/cargo" />
            <RutaLogged component={Roles} path="/roles" />
            <RutaLogged component={Permisos} path="/permisos" />
            <RutaLogged component={GestionarEmpresa} path="/empresas" />
            <RutaLogged component={Gestores} path="/gestores" />
            <RutaLogged component={OpcionesGestor} path="/opcionesgestor" />
            <RutaLogged component={PerfilGestor} path="/perfilgestor" />
            <RutaLogged component={AsignarCartera} path="/asignarcartera" />
            <RutaLogged component={Talleres} path="/listatalleres" />
            <RutaLogged component={ManodeObra} path="/listaobra" />
            <RutaLogged component={Repuestos} path="/listaderepuestos" />
            <RutaLogged component={TipoRegistros} path="/tiporegistros" />
            <RutaLogged component={Kilometraje} path="/kilometraje" />
            <RutaLogged component={Intermediarios} path="/intermediario" />
            <RutaLogged component={ClienteFinal} path="/clientefinal" />
            <RutaLogged component={Retail} path="/retail" />
            <RutaLogged component={OrdendePago} path="/ordenpago" />
            <RutaLogged component={Garantiasaporaprobar} path="/garantiasporaprobar" />
            <RutaLogged component={Descargarreportesorden} path="/reportesordenespago" />
            <RutaLogged component={OrdenLiquidadas} path="/ordenLiquidadas" />
            <RutaLogged component={StockDistribuidor} path="/stockdistribuidores" />
            <RutaLogged component={Activaciones} path="/activaciones" />
            <RutaLogged component={Descargarreportes} path="/descargarreportes" />
            <RutaLogged component={StockConsolidado} path="/stockconsolidado" />
            <RutaLogged component={SubirImagenes} path="/subirimagenes" />
            <RutaLogged component={GestionarAlmacenes} path="/gestionaralmaccenes" />
            <RutaLogged component={InventarioReportes} path="/inventarioreportes" />
            <RutaLogged component={GarantiasAprobadas} path="/garantiasaprobadas" />
            <RutaLogged component={Noticias} path="/noticias" />
            <RutaLogged component={MapaTalleres} path="/mapatalleres" />
          </Switch>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
